import { render, staticRenderFns } from "./NominationsTable.vue?vue&type=template&id=43fdaac3&"
import script from "./NominationsTable.vue?vue&type=script&lang=js&"
export * from "./NominationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports